// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PayloadWrapper__container-afbab0 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0 8px 0;
  position: relative;
  cursor: default !important;
}

.PayloadWrapper__payload-f80f64 {
  width: 100vw;
  max-width: var(--max-width-article-layout);
  margin-inline-start: 16px;
}

.PayloadWrapper__menu-bca42f {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
}

.PayloadWrapper__delete-b8e7b6 {
  position: absolute;
  inset-inline-end: 0;
  align-self: flex-start;
}

.PayloadWrapper__delete-button-c321d2 {
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0px;
}

.PayloadWrapper__re-upload-fc335b {
  position: absolute;
  inset-inline-end: 30px;
  align-self: flex-start;
}

.PayloadWrapper__drag-and-drop-icon-ee94ca {
  align-self: flex-start;
  width: 32px;
  height: 32px;
  fill: var(--base-70);
  cursor: grab;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/PayloadWrapper/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0BAAA;AACF;;AAEA;EACE,YAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 0 8px 0;\n  position: relative;\n  cursor: default !important;\n}\n\n.payload {\n  width: 100vw;\n  max-width: var(--max-width-article-layout);\n  margin-inline-start: 16px;\n}\n\n.menu {\n  width: 32px;\n  height: 32px;\n  flex: 0 0 auto;\n}\n\n.delete {\n  position: absolute;\n  inset-inline-end: 0;\n  align-self: flex-start;\n}\n\n.delete-button {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  padding: 0px;\n}\n\n.re-upload {\n  position: absolute;\n  inset-inline-end: 30px;\n  align-self: flex-start;\n}\n\n.drag-and-drop-icon {\n  align-self: flex-start;\n  width: 32px;\n  height: 32px;\n  fill: var(--base-70);\n  cursor: grab;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PayloadWrapper__container-afbab0`,
	"payload": `PayloadWrapper__payload-f80f64`,
	"menu": `PayloadWrapper__menu-bca42f`,
	"delete": `PayloadWrapper__delete-b8e7b6`,
	"delete-button": `PayloadWrapper__delete-button-c321d2`,
	"deleteButton": `PayloadWrapper__delete-button-c321d2`,
	"re-upload": `PayloadWrapper__re-upload-fc335b`,
	"reUpload": `PayloadWrapper__re-upload-fc335b`,
	"drag-and-drop-icon": `PayloadWrapper__drag-and-drop-icon-ee94ca`,
	"dragAndDropIcon": `PayloadWrapper__drag-and-drop-icon-ee94ca`
};
module.exports = ___CSS_LOADER_EXPORT___;
